export default __webpack_public_path__ + "7ae3fe8e9ddb216eb7ddb2908543d22a.png";